import React from "react";
import { Link } from "react-router-dom";
import SideBarNav from "./SideBarNav";
import { getAutoRenewals } from "../../modules/actions/autoRenewalActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt){
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
class AutoRenewal extends React.Component {
  componentDidMount() {
    this.props.getAutoRenewals();
  }
  render() {
    console.log("autorenewal", this.props);
    const { autoRenewalList } = this.props;
    console.log("autoRenewalList", autoRenewalList);
    return (
        <section className="BodyContainer">
          <div className="container">
            <div className="row">
              <SideBarNav />

              <div className="col-lg-8 order-history">
                <div className="mt-0">
                  <h4 className="features_title">Auto Renewal</h4>

                  <div style={{ clear: "both", height: "15px" }} />

                  <div className="table-responsive orders-list">
                    <table className="table">
                      <thead>
                      <tr>
                        <th>IMEI</th>
                        <th>Date</th>
                        <th>Order #</th>
                        <th>Plan Name</th>
                        <th>Plan Amount</th>
                        <th>Next Payment Date</th>
                        <th>Status</th>
                        <th />
                      </tr>
                      </thead>
                      <tbody>
                      {autoRenewalList.map(function(autoRenewal, index) {
                        return (
                            <tr key={index}>
                              <td>{autoRenewal.imei}</td>
                              <td>
                                {moment(autoRenewal.orderDate).format("MM/DD/YYYY")}
                              </td>
                              <td>
                                <Link to={`/dashboard/order/${autoRenewal.orderId}`}>
                                  {autoRenewal.orderId}
                                </Link>
                              </td>
                              <td>{(autoRenewal.useType === "GLOBAL" && typeof autoRenewal.country !== "undefined" && autoRenewal.country !== null) ? autoRenewal.country.name : autoRenewal.useType} {autoRenewal.recurring_profile.name}</td>
                              <td>{autoRenewal.subtotal !== autoRenewal.total ? (<span style={{textDecoration: "line-through"}}>${autoRenewal.subtotal}</span>) : null} ${autoRenewal.total}</td>
                              <td>
                                {moment(autoRenewal.startDate).format("MM/DD/YYYY")}
                              </td>
                              <td>{toTitleCase(autoRenewal.status)}</td>
                              <td>
                                {/*<Link to={`/dashboard/autorenewaldetail/${autoRenewal.profileId}`}>
                                View history
                              </Link>*/}
                              </td>
                            </tr>
                        );
                      })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}
AutoRenewal.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    autoRenewalList: state.autoRenewal.autoRenewalList
  };
}

export default connect(
    mapStateToProps,
    { getAutoRenewals, addFlashMessage }
)(AutoRenewal);



// WEBPACK FOOTER //
// ./src/pages/dashboard/AutoRenewal.js